module.exports = __webpack_public_path__ + "img/ep4-6.93c1aff5.png";